import {z} from 'zod'
import {nullFieldsToNull} from '@/validation-utils/ZodHelpers'
import {ContactInfoSchema} from '@/subaccount/types/ContactInfo'
import {AddressSchema} from '@/subaccount/types/Address'
import {SubAccountRelationTypeEnum} from '@/subaccount/types/SubAccount'

export const SubAccountCreatableSchema = z.object({
    relationType: SubAccountRelationTypeEnum,
    type: z.literal('SubAccountCreatable'),
    orgNo: z.string().nullish(),
    name: z.string().nullish(),
    contactInfo: z.preprocess(nullFieldsToNull, z.nullish(ContactInfoSchema)),
    address: z.preprocess(nullFieldsToNull, z.nullish(AddressSchema)),
    bban: z.string().nullish(),
    iban: z.string().nullish(),
    bic: z.string().nullish()
})

export type SubAccountCreatable = z.infer<typeof SubAccountCreatableSchema>